import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=23adb44a&scoped=true&"
import script from "./ClaimList.vue?vue&type=script&lang=js&"
export * from "./ClaimList.vue?vue&type=script&lang=js&"
import style0 from "./ClaimList.vue?vue&type=style&index=0&id=23adb44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adb44a",
  null
  
)

export default component.exports